module.exports = require('./helpers/bundle-url').getBundleURL('9iXDo') + "meme-6.e4d1f5eb.mp4" + "?" + Date.now();